import React from 'react';

import './contact-form.scss';
import cs from "classnames";
import ContactFormInput from '../../contact-form-input/contact-form-input';



const ContactFormCn = ({ formId }) => {
	const [ success, setSuccess ] = React.useState(false);
	const [ error, setError ] = React.useState(false);
	const [ company, setCompany ] = React.useState();
	const [ project, setProject ] = React.useState();
	const [ email, setEmail ] = React.useState();
	const [ phone, setPhone ] = React.useState();
	const [ name, setName ] = React.useState();
	const [ country, setCountry ] = React.useState();
	const width = window.innerWidth;



	const onSubmit = event => {
		event.preventDefault();

		const url = '/svalka/api/expressform/';
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ company, project, email, phone, name })
		};

		fetch(url, requestOptions)
			.then((response => response.json()))
			.then((json) => {
				const { ok, text } = json;
				if (ok) {
					setSuccess(true);
					setError(false);
					if (window.ym) {
						window.ym(5320750,'reachGoal','com_order_sent');
					}
					return;
				}

				if (text) {
					window.alert(text);
					return;
				}

				setError(true);
				setSuccess(false);
			})
			.catch(() => {
				setError(true);
				setSuccess(false);
			})
	}

	return (
		<React.Fragment>
			<section className="contactus" id="contact">
				<div
					id="l-express-form-container"
					className={cs(
						"contactus_form",
						{
							"success": success,
							"error": error
						}
					)}
				>
					<h2 className="header">订购设计</h2>
					<p>请填写项目内容，我们将主动联系您探讨详情。</p>
					<form onSubmit={onSubmit}>
						<ContactFormInput
							placeholder="公司名称"
							name="company"
							onChange={setCompany}
						/>
						<ContactFormInput
							placeholder="项目概况"
							name="project"
							onChange={setProject}
						/>
						<ContactFormInput
							placeholder="邮件地址"
							name="email"
							onChange={setEmail}
						/>
						<ContactFormInput
							placeholder="联系电话"
							name="Phone"
							onChange={setPhone}
						/>
						<ContactFormInput
							placeholder="客户姓名"
							name="name"
							onChange={setName}
						/>
						<ContactFormInput
							placeholder="国家/地区"
							name="country"
							onChange={setCountry}
						/>
						<button type="submit">发送</button>
						<input type="hidden" name="form_id" value={formId} />
					</form>
					<div className="contactus_success">
						<h2>感谢您的来信<br/>我们将稍后与您联系</h2>
					</div>
					<div className="contactus_error">
						<h2>错误<br/>请稍后再次尝试</h2>
					</div>
				</div>
			</section>
		</React.Fragment>
	);
}

export default ContactFormCn;
